import { useState } from "react";
import { faqs } from "@/mocks/news";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section className="bg-background-100 border-y border-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-[380px_1fr] gap-8 lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 mb-2">
              <span className="w-4 h-0.5 bg-primary-500 rounded-full"></span>
              常见问题
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
              关于「独家吃瓜」
            </h2>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed font-label">
              这里是读者最常问到的几个问题。如果还有疑问，欢迎通过联系我们页面留言，我们会在一个工作日内回复。
            </p>
            <div className="mt-6 p-4 rounded-lg bg-secondary-50 border border-secondary-200">
              <p className="text-sm text-secondary-800 font-label flex items-start gap-2">
                <i className="ri-information-line text-secondary-600 mt-0.5"></i>
                本站内容为公开资讯整理，涉及未经官方确认的部分均会标注说明。
              </p>
            </div>
          </div>

          <div className="space-y-3">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? -1 : index)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-medium text-foreground-900 font-label">
                        {item.q}
                      </span>
                      <i
                        className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50 ri-subtract-line"
                            : "bg-background-200 text-foreground-600 ri-add-line"
                        }`}
                      ></i>
                    </button>
                  </h3>
                  {isOpen && (
                    <div className="px-5 pb-4 -mt-1">
                      <p className="text-sm text-foreground-600 leading-relaxed font-label">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}